import { defineMessages } from 'react-intl';

import { Cryptocurrency } from '@sorare/core/src/__generated__/globalTypes';
import type { RefineListProps } from '@sorare/core/src/components/search/RefineList';
import { cryptocurrencySymbols } from '@sorare/core/src/lib/cryptocurrency';
import { FILTERS } from '@sorare/core/src/lib/filters';
import { glossary } from '@sorare/core/src/lib/glossary';

import { makeFilter } from 'searchCards/RefineList';

const optionsForActiveFilters = defineMessages({
  eth: {
    id: 'searchCards.RefineSettlementWallets.activeFilter.eth',
    defaultMessage: 'ETH accepted',
  },
  sol: {
    id: 'searchCards.RefineSettlementWallets.activeFilter.sol',
    defaultMessage: 'SOL accepted',
  },
  cash: {
    id: 'searchCards.RefineSettlementWallets.activeFilter.cash',
    defaultMessage: 'Cash accepted',
  },
});

export const getFormatSettlementWallets: (
  forActiveFilters: boolean
) => NonNullable<RefineListProps['formatOption']> = (
  forActiveFilters: boolean
) => {
  const formatSettlementWallets: NonNullable<
    RefineListProps['formatOption']
  > = (option, formatMessage) => {
    switch (option) {
      case 'eth':
        return forActiveFilters
          ? formatMessage(optionsForActiveFilters.eth)
          : cryptocurrencySymbols[Cryptocurrency.WEI];
      case 'fiat':
        return formatMessage(
          forActiveFilters ? optionsForActiveFilters.cash : glossary.cash
        );
      case 'sol':
        return forActiveFilters
          ? formatMessage(optionsForActiveFilters.sol)
          : cryptocurrencySymbols[Cryptocurrency.LAMPORT];
      default:
        return formatMessage(
          forActiveFilters ? optionsForActiveFilters.cash : glossary.cash
        );
    }
  };
  return formatSettlementWallets;
};

export const RefineSettlementWallets = makeFilter(FILTERS.settlementWallets, {
  searchable: false,
  formatOption: getFormatSettlementWallets(false),
  sortBy: ['name:desc'],
});
